<ng-container *ngIf="{ request: returnRequest$ | async } as content">

  <div class="page-title simple-card">
		<page-title [isBackButtonVisible]="true" [backButtonTitle]="'Back to My Returns'" [backButtonRedirectPage]="'returns'"></page-title>
  </div>

  @if (!content.request?.isPristine) {
    @if (!content.request?.isLoading) {
      @if (!content.request?.hasError) {
        @if (content.request) {
          <div class="m-t-20 col-12 col-md-3 ml-auto">
            <button type="button" class="btn btn-secondary btn-sm w-100" (click)="exportDetailsOrder()">
              <span class="material-symbols-outlined d-flex m-r-4"> download </span>
              {{ 'exportEntries.exportToExcel' | cxTranslate }}
            </button>
          </div>

          <div class="m-t-20 row">
            <div class="col-12 col-md-6">
              <div class="review-summary">
                <div class="cx-review-summary-card simple-card po-box">
                  <div class="w-100">
                    <p class="title m-0 d-flex v-center">
                      <span class="material-symbols-outlined icon"> grading </span>
                      <span class="m-b-0">{{ 'return.details.orderDetails' | cxTranslate }}</span>
                    </p>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'return.details.returnOrder' | cxTranslate }}: </span>
                    <span class="value">
                      {{ content.request?.return?.orderNumber }}
                    </span>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'return.details.orderStatus' | cxTranslate }}: </span>
                    <span class="value">
                      {{ content.request?.return?.orderStatus }}
                    </span>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'return.details.orderDate' | cxTranslate }}: </span>
                    <span class="value">
                      {{ content.request?.return?.orderDate | date: 'MM/dd/yyyy'}}
                    </span>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'return.details.requestDate' | cxTranslate }}: </span>
                    <span class="value">
                      {{ content.request?.return?.requestDate | date: 'MM/dd/yyyy' }}
                    </span>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'return.details.bookedDate' | cxTranslate }}: </span>
                    <span class="value">
                      {{ content.request?.return?.bookedDate | date: 'MM/dd/yyyy' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6">
              <div class="review-summary">
                <div class="cx-review-summary-card simple-card po-box">
                  <div class="w-100">
                    <p class="title m-0 d-flex v-center">
                      <span class="material-symbols-outlined icon"> request_quote </span>
                      <span class="m-b-0">{{ 'return.details.orderPricingSummary' | cxTranslate }}</span>
                    </p>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'return.details.orderSubTotal' | cxTranslate }}: </span>
                    <span class="value float-right">
                      {{ content.request?.return?.orderPricingSummary.orderSubTotal?.formattedValue }}
                    </span>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'return.details.tariffSurcharge' | cxTranslate }}: </span>
                    <span class="value float-right">
                      {{ content.request?.return?.orderPricingSummary.tariffSurcharge?.formattedValue }}
                    </span>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'return.details.shippingHandling' | cxTranslate }}: </span>
                    <span class="value float-right">
                      {{ content.request?.return?.orderPricingSummary.shippingHandling?.formattedValue }}
                    </span>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'return.details.orderTotal' | cxTranslate }}: </span>
                    <span class="value float-right">
                      {{ content.request?.return?.orderPricingSummary.orderTotal?.formattedValue }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="m-t-20 row">
            <div class="col-12 col-md-6">
              <div class="review-summary">
                <div class="cx-review-summary-card simple-card po-box">
                  <div class="w-100">
                    <p class="title m-0 d-flex v-center">
                      <span class="material-symbols-outlined icon"> price_check </span>
                      <span class="m-b-0">{{ 'return.details.paymentMethod' | cxTranslate }}</span>
                    </p>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'return.details.poNumber' | cxTranslate }}: </span>
                    <span class="value">
                      {{ content.request?.return?.paymentMethod.poNumber }}
                    </span>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'return.details.paymentTerms' | cxTranslate }}: </span>
                    <span class="value">
                      {{ content.request?.return?.paymentMethod.paymentTerms }}
                    </span>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'return.details.billingAddress' | cxTranslate }}: </span>
                    <span class="value">
                      <div [innerHTML]="content.request?.return?.paymentMethod.billingAddress"></div>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6">
              <div class="review-summary">
                <div class="cx-review-summary-card simple-card po-box">
                  <div class="w-100">
                    <p class="title m-0 d-flex v-center">
                      <span class="material-symbols-outlined icon"> local_shipping </span>
                      <span class="m-b-0">{{ 'return.details.shippingInformation' | cxTranslate }}</span>
                    </p>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'return.details.shippingAddress' | cxTranslate }}: </span>
                    <span class="value" >
                      <div [innerHTML]="content.request?.return?.shippingInformation.address"></div>
                    </span>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'return.details.shippingMethod' | cxTranslate }}: </span>
                    <span class="value ">
                      {{ content.request?.return?.shippingInformation.method }}
                    </span>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'return.details.freightTerms' | cxTranslate }}: </span>
                    <span class="value">
                      {{ content.request?.return?.shippingInformation.freightTerms }}
                    </span>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'return.details.email' | cxTranslate }}: </span>
                    <span class="value">
                      {{ content.request?.return?.shippingInformation.email }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="m-t-20 row">
            <div class="col-12">
            <div class="review-summary">
              <div class="cx-review-summary-card simple-card">
                <div class="w-100">
                  <p class="title m-0 d-flex v-center">
                    <span class="material-symbols-outlined icon"> category </span>
                    <span class="m-b-0">{{ 'return.details.items' | cxTranslate }}</span>
                  </p>
                </div>
              </div>
              <div class="m-t-20">
                <custom-cx-cart-item-list [items]="content.request?.return?.lines || []" [readonly]="true"></custom-cx-cart-item-list>
              </div>
            </div>
            </div>
          </div>
        } @else {
          <p class="text-center ff-bold m-0">{{ 'return.details.noContent' | cxTranslate }}</p>
        }
      }
    } @else {
      <div class="loader w-100 m-t-20">
        <local-loader></local-loader>
      </div>
    }
  }
</ng-container>
